import React from 'react';

import { InfoBanner, EmailLink } from './index.styles';
import { MessageBannerProps, InfoBannerT } from './index.types';

type BannerContentT = {
  [key: string]: {
    bannerType?: InfoBannerT;
    message?: string | React.ReactNode;
  };
};

const SupportEmailLink = () => (
  <>
    <EmailLink href="mailto:support@ordermentum.com">contact support</EmailLink>{' '}
    for assistance.
  </>
);

const BannerContent: BannerContentT = {
  welcomeBack: {
    bannerType: 'success',
    message: 'Welcome back, please sign in to accept the invitation.',
  },
  error: {
    bannerType: 'error',
    message: (
      <>
        Unfortunately we cannot create your account.
        <br />
        Please <SupportEmailLink />
      </>
    ),
  },
  expiredInvitation: {
    bannerType: 'error',
    message: (
      <>
        The invitation link you are trying to use has expired.
        <br />
        Please sign in or <SupportEmailLink />
      </>
    ),
  },
};

export const MessageBanner = (props: MessageBannerProps) => {
  const banner = BannerContent[props.type];
  const { bannerType, message } = banner;

  return (
    <>
      {bannerType && (
        <InfoBanner type={bannerType}>{message && message}</InfoBanner>
      )}
    </>
  );
};
